import React, {useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, CircularProgress } from '@mui/material';

import { getOneQuestion } from '../../../actions/questions';
import HostNavButton from '../HostNavButton/HostNavButton';
import PlainQuestion from './Question/PlainQuestion';
import MCAnswers from './Answers/MCAnswers';
import Timer from './Timer/Timer';
import { COLOR_TEXT_MUTED } from '../../../constants/styleValues';

const Quiz = () => {
    
    const dispatch = useDispatch();

    const componentContent = {
        language_DE:{
            question:'Frage'
        },
        language_EN:{
            question:'Question'
        },
        language_FR:{
            question:'Question'
        }
    }
    
    //++++++++++++++++STORE SELECTOR++++++++++++++++
    const playQuiz = useSelector((state) => state.PlayQuiz);
    const currentQuestion = useSelector((state) => state.Question); //get the currentquestion to show the sub components only when the question is ready
    const selectedLanguage = useSelector((state) => state.Language); //get the selected language from the store. set within navigation component

    const playQuizNavQuestion = playQuiz.navigation.currentQuestion;
    const playQuizCurrentQuestion = playQuiz.questions[playQuizNavQuestion]; //get the current question ID - this id is used to grab the question data object from db

    //++++++++++++++++USE EFFECT EVENTS++++++++++++++++
    useEffect(() => {
        if(!currentQuestion){
            dispatch(getOneQuestion(playQuizCurrentQuestion.questionId)); //get the question according to the questionId within playQuiz and push it to the store
        }   
    });
    
    return(
        <Grid container justifyContent="center" alignItems="center" textAlign="center" sx={{flex: 1, px: {xs: 2, sm: 3}, pt: 3, pb: 4}}>
            {!currentQuestion ?
                <CircularProgress color="secondary" />
            :
            <Grid container justifyContent="center" alignItems="center" textAlign="center" maxWidth="sm" sx={{margin: '0 auto'}}>
                <Grid item xs={12} mb={1}>
                    <Typography variant='overline' sx={{color: COLOR_TEXT_MUTED, letterSpacing: '0.04em'}}>
                        {componentContent[selectedLanguage].question} {playQuiz.navigation.currentQuestion +1 }/{playQuiz.questions.length}
                    </Typography>
                </Grid>
                <Timer/>
                <Grid container mb={1} mt={1}>
                    {(() => {
                        switch (currentQuestion.settings.questionType) {
                            case "plain": return <PlainQuestion />;
                            default: return <PlainQuestion />;
                        }
                    })()}

                </Grid>
                <Grid container>
                    {(() => {
                        switch (currentQuestion.settings.answerType) {
                            case "MC": return <MCAnswers />;
                            default: return <MCAnswers />;
                        }
                    })()}
                </Grid>
                <HostNavButton/>
            </Grid>
            }
        </Grid>

    )
}

export default Quiz